<div class="modal-header blue">
  <h4 class="modal-title">
    Edit Group Enrollment Instruction | {{ groupEnrollmentID }}
  </h4>
  <a href="javascript:void(0)" (click)="close()" class="modal-close-btn"></a>
</div>

<div class="modal-body" [formGroup]="noteFrom">
  <div class="input-label">Enrollment Instruction</div>

  <div class="input-wrap w-100">
    <textarea
      placeholder="Enter Notes"
      formControlName="notes"
      rows="8"
      [class.is-invalid]="
        noteFrom.get('notes')?.invalid && noteFrom.get('notes')?.touched
      "
    ></textarea>
  </div>
  <div
    class="invalid-feedback text-left d-block"
    *ngIf="noteFrom.get('notes')?.invalid && noteFrom.get('notes')?.touched"
  >
    <div *ngIf="noteFrom.get('notes')?.errors?.required">
      This field is required
    </div>
  </div>
</div>

<div class="modal-footer">
  <button
    type="submit"
    (click)="save()"
    [disabled]="noteFrom.invalid || isLoading"
    class="button ml-auto w-100px"
  >
    Save
  </button>
</div>
